$ = require 'jquery'
Auth = require 'app/scripts/db/auth'
AutoInsertionView = require 'app/scripts/views/internal/autocomplete/auto-insertion-view'
CompleterUtil = require 'app/scripts/views/internal/autocomplete/completer-util'
CheckItemMenuView = require 'app/scripts/views/checklist/check-item-menu-view'
{ CheckItemOverflowMenu } = require 'app/src/components/CheckItemOverflowMenu/CheckItemOverflowMenu'
Dates = require 'app/scripts/lib/dates'
{ dontUpsell } = require '@trello/config'
DueDateHelpers = require 'app/scripts/views/internal/due-date-helpers'
View = require 'app/scripts/views/internal/view'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ forNamespace } = require 'app/common/lib/util/i18n'
getExperiment = require 'app/scripts/lib/experiments/simple-test'
moment = require 'moment'
{ OrganizationFeature } = require '@trello/product-features'
PopOver = require 'app/scripts/views/lib/pop-over'
TFM = require 'app/scripts/lib/markdown/tfm'
Util = require 'app/scripts/lib/util'
friendlyLinks = require 'app/scripts/views/internal/friendly-links'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
{ renderComponent } = require 'app/src/components/ComponentWrapper'
{ track, trackUe, Verb, Noun } = require '@trello/analytics'
t = require('app/scripts/views/internal/teacup-with-helpers')('checklist_item')
{ toggleAssignPopoverV2 } = require 'app/scripts/views/checklist/toggle-assign-popover'
{ toggleDatePopoverV2 } = require 'app/scripts/views/checklist/toggle-date-popover'
{ toggleUpsellAdvancedChecklist } = require 'app/scripts/views/checklist/upsell-advanced-checklist'
{ toggleClearPopover } = require 'app/scripts/views/checklist/toggle-clear-popover'
_ = require 'underscore'
urls = require 'app/scripts/controller/urls'
memberAvatarTemplate = require 'app/scripts/views/templates/member_avatar'
Layout = require 'app/scripts/views/lib/layout'
{ getKey, Key, registerShortcutHandler, Scope, unregisterShortcutHandler } = require '@trello/keybindings'
{ ELEVATION_ATTR } = require '@trello/layer-manager'

#Helpers File
{ commitCheckItemEdits, checkItemEditControlKeydown, renderEditItemButtons, onCheckItemClick, clearEdits, checkItemKeydownEvent, saveCheckItemDrafts, recallCheckItemDrafts, validateCheckItemInput, getCheckItemEdits, _checkItemDraftKey, _saveCheckItemDraft, _recallCheckItemDraft, _discardCheckItemDraft, editCheckItem } = require './check-item-edit-helpers'

viewTitle = forNamespace('view title')

template = t.renderable ({ editable, showAssignBadge, showDueDateBadge, showNewOverflowMenu }) ->
  t.div '.checklist-item-checkbox', { class: t.classify({ enabled: editable, 'js-toggle-checklist-item': editable }) }, ->
    t.icon 'check', { class: 'checklist-item-checkbox-check' }

  t.div '.checklist-item-details.non-empty.js-checkitem', { class: t.classify({ editable }), attr: 'name' }, ->
    t.div '.checklist-item-row.js-checkitem-row.current', ->
      t.div '.checklist-item-text-and-controls.hide-on-edit', ->
        t.span '.checklist-item-details-text.markeddown.js-checkitem-name'
        t.div '.checklist-item-controls', ->
          if showDueDateBadge
            t.span '.checklist-item-due.js-checklist-item-due'
          if showAssignBadge
            t.span '.checklist-item-assignee.js-checklist-item-assignee'
          if editable
            if showNewOverflowMenu
              t.div '.checklist-item-menu.rmk-new.ignore-editable-view.js-new-overflow-button'
            else
              t.div '.checklist-item-menu.rmk-old.js-open-menu', 'data-test-id': 'checklist-item-overflow-menu-button', ->
                t.span '.icon-sm.icon-overflow-menu-horizontal'

      if editable
        ##CheckItem Edit Controls appended by check-item-edit-helpers
        t.div '.edit.check-item-options-menu', ->
          t.textarea '.field.full.single-line.js-checkitem-input', { type: 'text' }
          t.p '.edits-error.error'

    if editable
      t.p '.edits-warning.quiet', ->
        t.format 'you-have-unsaved-edits-on-this-field'
        t.text ' '
        t.a '.js-view-edits', { href: '#' }, ->
          t.format 'view-edits'
        t.text " - "
        t.a '.js-discard-edits', { href: '#' }, ->
          t.format 'discard'

assigneeTemplate = t.renderable ({ member }, canEdit, advancedChecklistsEnabled, showUpsell) ->
  if advancedChecklistsEnabled || member || showUpsell
    memberAvatar = ->
      t.div '.member.m-member-mod-24', {
        class: t.classify({
          'long-initials': member.initials?.length > 2,
          'member-deactivated': member.isDeactivated || member.activityBlocked
        })
      }, ->
        memberAvatarTemplate(member)

    if canEdit
      showClear = member && !advancedChecklistsEnabled

      t.button '.subtle', {
        class: t.classify({
          'js-assign': !showClear
          'js-clear-assignment': showClear
        }),
      }, ->
        if member
          memberAvatar()
        else
          t.icon 'add-member'
    else if member
      t.span '.disabled', ->
        memberAvatar()

dueTemplate = t.renderable (due, className, canEdit, advancedChecklistsEnabled, showUpsell) ->
  if advancedChecklistsEnabled || due || showUpsell
    if canEdit
      showClear = due && !advancedChecklistsEnabled

      t.button ".subtle.#{ className }", {
        class: t.classify({
          'js-due': !showClear,
          'js-clear-due': showClear
        })
      }, ->
        t.icon 'clock'
        if due
          t.text due
    else if due
      t.span '.disabled', { class: className }, ->
        t.icon 'clock'
        t.text due

module.exports = mixin AutoInsertionView, CompleterUtil, class CheckItemView extends View
  className: 'checklist-item'

  allowNewlines: false

  initialize: ->
    @_reactContainers = new Set()

    @listenTo @model,
      'change:name': ->
        @renderName()
        @renderAssignee()
        @renderDue()
      'change:state': ->
        @renderState()
        @renderDue()
      'change:due': ->
        @renderDue()
        @renderEditItemButtons()
      'change:idMember': ->
        @renderAssignee()
        @renderEditItemButtons()


    super

    $(window).on "beforeunload.EditableView-#{@model.cid}", =>
      @saveCheckItemDrafts('unload')
      return

  events:
    #Editable Helper Events
    'click .js-checkitem-row': 'onCheckItemClick'
    'click .js-cancel-edit': 'clearEdits'
    'click .js-discard-edits': 'clearEdits'
    'click .js-view-edits': 'onCheckItemClick'
    'click .js-save-edit': 'commitCheckItemEdits'
    'keydown .field': 'checkItemKeydownEvent'
    'keydown .edit-controls': 'checkItemEditControlKeydown'

    'click textarea': Util.stopPropagation

    #CheckItem In File
    'keyup .field': (e) ->
      if getKey(e) == Key.Escape
        # Don't let the keyup propagate; we want to handle PopOvers differently;
        # (we wait until keydown so we won't cancel editing if a PopOver is open)
        Util.stop(e)

        if PopOver.isVisible
          PopOver.hide()

        else
          @clearEdits(e)

      @keyAutoMention(e)

    'click .js-toggle-checklist-item': 'toggleState'

    'click .js-open-menu': 'openMenu'

    'click .js-open-mention-selector': 'commentMentionMember' ##in completer-util
    'click .js-open-emoji-selector': 'commentAddEmoji' ##in completer-util
    'movecheckitem': 'moveCheckItem'

    'mouseenter': ->
      if !@model.editable()
        return

      if !@model.getBoard()?.hasAdvancedChecklists()
        return

      registerShortcutHandler(@onShortcut, { scope: Scope.DialogSection, clearScope: true })

    'mouseleave': ->
      unregisterShortcutHandler(@onShortcut)

    # Advanced Checklists
    'click .js-assign:not([disabled])': (e) ->
      @assignUpsellOrPopover(e, {
        trackingMethod: 'by clicking member button in checkitem view'
      })

    'click .js-due:not([disabled])': (e) ->
      @dueDateUpsellOrPopover(e, {
        trackingMethod: 'by clicking due date badge in checkitem view'
      })

    'click .js-clear-assignment:not([disabled])': (e) ->
      toggleClearPopover({
        title: viewTitle('assign'),
        message: t.l('clear-assignment-message'),
        removeText: t.l('clear-assignment'),
        clear: => @_setMember(null)
        upsell: @_hasUpsell()
      })(e)

    'click .js-clear-due:not([disabled])': (e) ->
      toggleClearPopover({
        title: viewTitle('change due date'),
        message: t.l('clear-due-message'),
        removeText: t.l('clear-due'),
        clear: => @_setDue(null)
        upsell: @_hasUpsell()
      })(e)

  onShortcut: (event) =>
    key = getKey(event)

    switch key
      when Key.Space
        myId = Auth.myId()
        @_setMember(if @model.get('idMember') == myId then null else myId)
        track 'Keyboard Shortcuts', 'Space - Toggle Assigning Self', 'Check Item'
      when Key.a, Key.m
        @$('.js-assign').click()
        track 'Keyboard Shortcuts', 'A - Assign Members', 'Check Item'
      when Key.d
        @$('.js-due').click()
        track 'Keyboard Shortcuts', 'D - Due Dates', 'Check Item'
      else
        return

    event.preventDefault()
    return

  dueDateUpsellOrPopover: (e, { trackingMethod, billingUrl }) ->
    if @model.getBoard()?.hasAdvancedChecklists()
      toggleDatePopoverV2({
        title: viewTitle('change due date'),
        setDate: (date) => @_setDue(date, 'by clicking a date in the due date picker')
        getInitialDate: => @model.get('due')
        trackingMethod,
      })(e)
    else if @_hasUpsell()
      toggleUpsellAdvancedChecklist({
        trackingMethod: 'by clicking due date button in checkitem composer',
        billingUrl: @getBillingUrl()
      })(e)

  assignUpsellOrPopover: (e, { trackingMethod }) ->
    card = @model.getCard()
    board = @model.getBoard()

    if @model.getBoard()?.hasAdvancedChecklists()
      toggleAssignPopoverV2({
        title: viewTitle('assign'),
        getCardMembers: => card.memberList.filterDeactivated(force: true, model: board).toJSON()
        getBoardMembers: => board.memberList.filterDeactivated(force: true).toJSON()
        trackingMethod,
        getInitialMember: => @model.get('idMember'),
        setMember: (idMember) =>
          @_setMember(idMember)
      })(e)
    else if @_hasUpsell()
      toggleUpsellAdvancedChecklist({
        trackingMethod: 'by clicking member button in checkitem composer',
        billingUrl: @getBillingUrl()
      })(e)

  getCard: -> @model.getCard()

  getBillingUrl: ->
    org = @model.getBoard().getOrganization()
    if org?
      urls.getOrganizationBillingUrl(org)

  advancedCheckItemFromModel: ->
    return {
      name: @model.get('name'),
      validAssigneeUsernames: @model.getBoard().memberList.map((member) -> member.get('username'))
      orgProductNumber: @model.getBoard()?.getOrganization()?.getProduct()
    }

  render: ->
    view = @
    model = @model

    editable = @model.editable()
    shouldShowNewOverflowMenu = featureFlagClient.get('remarkable.checkitem-overflow-rewrite', false)

    _hasAdvancedChecklists = Boolean(@model.getBoard()?.hasAdvancedChecklists())
    _hasUpsell = @_hasUpsell()

    @$el.html(
      template({
        showAssignBadge: _hasAdvancedChecklists || _hasUpsell || @model.get('idMember')?
        showDueDateBadge: _hasAdvancedChecklists || _hasUpsell || @model.get('due')?
        editable: editable
        showNewOverflowMenu: shouldShowNewOverflowMenu
      })
    )

    @renderAssignee()
    @renderDue()
    @renderName()
    @renderState()
    @recallCheckItemDrafts()

    newOverflowButton = @el.querySelector('.js-new-overflow-button')

    if shouldShowNewOverflowMenu
      @renderOverflowButton(newOverflowButton, { editableView: false })

    @unmountUnusedReactComponents()

    @

#getTextInput, getMentionTarget, getEmoji Target all used for CompleteUtil and AutoInsertion
  getTextInput: ->
    @$('.js-checkitem-input')

  getMentionTarget: ->
    @$('.js-open-mention-selector')[0]

  getEmojiTarget: ->
    @$('.js-open-emoji-selector')[0]

  _hasUpsell: ->
    Boolean(@model.getBoard()?.upsellAdvancedChecklists())

  renderName: (e) ->
    name = @model.get('name')

    @$('.js-checkitem-row').data('unmarkeddown', name)

    nameHtml = TFM.checkItems.format(name, { textData: @model.get('nameData') }).output
    $name = @$('.js-checkitem-name')
    $name.empty().append(nameHtml)

    friendlyLinks $name[0], @model.getBoard()
    return

  renderAssignee: ->
    $assignee = @$('.js-checklist-item-assignee')
    if !$assignee.length
      return

    _hasAdvancedChecklists = Boolean(@model.getBoard()?.hasAdvancedChecklists())

    predicate =
      # If there is a member in model.get('idMember'), check for that
      if (idMember = @model.get('idMember'))?
        (member) -> member.id == idMember

    member =
      if predicate?
        @model.getBoard().memberList.find(predicate)

    memberProp = member?.toJSON()
    memberProp?.isDeactivated = @model?.getBoard()?.isDeactivated(member)

    $assignee.html(assigneeTemplate({
      member: memberProp
    }, @model.editable(), _hasAdvancedChecklists, @_hasUpsell()))
    .toggleClass('unset', !member?)

    @$el.toggleClass('no-assignee', !member?)

    return

  renderDue: ->
    $due = @$('.js-checklist-item-due')

    if !$due.length
      return

    _hasAdvancedChecklists = Boolean(@model.getBoard()?.hasAdvancedChecklists())

    due = @model.get('due')

    dueText = due && Dates.toDateString(due)

    className =
      if due
        complete = @model.get('state') == 'complete'
        DueDateHelpers.classForDueDate(moment(due).toDate(), complete)
      else
        ""

    $due.html(dueTemplate(dueText, className, @model.editable(), _hasAdvancedChecklists, @_hasUpsell()))
    .toggleClass('unset', !due)

    @$el.toggleClass('no-due', !due)

    return

  renderState: (e) ->
    data = @model.toJSON()
    data.checked = (data.state == 'complete')
    @$el.toggleClass('checklist-item-state-complete', data.checked)
    return

  toggleState: (e) ->
    return if !@model.editable()

    isComplete = @model.get('state') == 'complete'

    newState = if isComplete then 'incomplete' else 'complete'

    if newState == 'complete'
      @$el.addClass('checklist-item-fade-out')

      @setTimeout =>
        @model.update('state', newState)
        @$el.removeClass('checklist-item-fade-out')
      , 200

    else
      @$el.removeClass('checklist-item-fade-out')
      @model.update('state', newState)

    track("Checklist", "Toggle Checklist Item State", newState)

    return

  moveCheckItem: (e, ui, checklist, toDifferentChecklist) ->
    if !toDifferentChecklist && @model.getChecklist() != checklist
      # We've already handled this as a move to a different checklist
      return

    checkItems = ui.item.parent().children()
    index = checkItems.index(ui.item)
    pos = checklist.calcPos(index, @model)

    if toDifferentChecklist
      @model.update { pos, idChecklist: checklist.id }
      @model.collection.remove(@model)
      checklist.checkItemList.add(@model)
    else
      @model.update('pos', pos)

    checklist.checkItemList.sort({ silent: true })

    track("Checklist", "Reorder Checklist Item")

  _setDue: (date, trackingMethod) ->
    prevDate = @model.get('due')

    @model.update('due', date)

    verb =
      if !prevDate && date
        'adds'
      else if !date && prevDate
        'removes'
      else
        'changes'
    trackUe('card detail', verb, 'due date', 'on checkitem', '', trackingMethod || 'by clicking a submit button in due date picker')

  _setMember: (idMember) ->
    prevMember = @model.get('idMember')

    @model.update('idMember', idMember)

    verb =
      if !prevMember && idMember
        'adds'
      else if !idMember && prevMember
        'removes'
      else
        'changes'
    trackUe('card detail', verb, 'member', 'on checkitem', '', 'by clicking a submit button in member picker')

  openMenu: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: e.target
      view: CheckItemMenuView
      options: { @model, @modelCache }
      keepEdits: true

  remove: ->
    unregisterShortcutHandler(@onShortcut)
    @unmountAllReactComponents()
    @saveCheckItemDrafts('removing view')
    $(window).off ".EditableView-#{@model.cid}"

    super

  # Wrapper around `renderComponent` that also "keeps track" of the mount point
  renderOverflowButton: (el, props) ->
    if el
      ##The new stack races the old stack and often believes the closest elevation is 0
      ##This makes sure that it always finds the card back button correctly at Elevation 1
      el.setAttribute(ELEVATION_ATTR, 1)
      renderComponent(React.createElement(CheckItemOverflowMenu, _.extend({ model: @model }, props)), el)
      @_reactContainers.add(el)

    @

  # Unmounts any react components whose containers are no longer contained by the backbone view
  unmountUnusedReactComponents: ->
    Array.from(@_reactContainers).filter (container) =>
     !@el.contains(container)
    .forEach (container) =>
     ReactDOM.unmountComponentAtNode(container)
     @_reactContainers.delete(container)

  unmountAllReactComponents: ->
    Array.from(@_reactContainers).forEach (container) =>
      ReactDOM.unmountComponentAtNode(container)
      @_reactContainers.delete(container)


  #Edit Helper Function Mapping
  validateCheckItemInput: validateCheckItemInput ##called in commitCheckItemEdits
  onCheckItemClick: onCheckItemClick
  saveCheckItemDrafts: saveCheckItemDrafts
  recallCheckItemDrafts: recallCheckItemDrafts
  getCheckItemEdits: getCheckItemEdits
  checkItemKeydownEvent: checkItemKeydownEvent
  clearEdits: clearEdits
  commitCheckItemEdits: commitCheckItemEdits
  renderEditItemButtons: renderEditItemButtons
  editCheckItem: editCheckItem ##called in onCheckItemClick
  checkItemEditControlKeydown: checkItemEditControlKeydown
  _checkItemDraftKey: _checkItemDraftKey
  _saveCheckItemDraft: _saveCheckItemDraft
  _recallCheckItemDraft: _recallCheckItemDraft
  _discardCheckItemDraft:  _discardCheckItemDraft

